export default __webpack_public_path__ + "static/media/kafkaDark.9b2f9555.svg";